import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormTriggerActionButton,
  title: 'Form Action Trigger',
  category: ComponentCategory.FormControls,
};
